import React from 'react';
import { ACCESS_TYPES } from './dictionary';

const Contributors = ({ contributors, canAssignUsers }) => {
    const MAX = 3;

    return (
        <div className="d-flex align-items-center gap-3">
            {!!contributors.length && (
                <div className="d-flex align-items-center gap-1">
                    {contributors.slice(0, MAX).map(contributor => (
                        <Contributor
                            contributor={contributor}
                            key={contributor.id}
                        />
                    ))}
                    {contributors.length > MAX && (
                        <ContributorsDropdown contributors={contributors.slice(MAX)} />
                    )}
                </div>
            )}
            <button
                type="button"
                className="btn btn-light btn-sm fw-bold"
                data-bs-toggle="modal"
                data-bs-target="#manageAccessModal"
                disabled={!canAssignUsers}
            >
                Manage access
            </button>
        </div>
    );
}

const Contributor = ({ contributor: { user, accessType, designation, avatarRingColor } }) => {

    return (
        <div
            className={`border border-2 rounded-circle border-${avatarRingColor}`}
            style={{ padding: '2px' }}
        >
            <div className="tooltip-container">
                <UserAvatar user={user} />
                <div className="tooltip-text tooltip-dark">
                    {user.fullname} - {designation || ACCESS_TYPES[accessType]}
                </div>
            </div>
        </div>
    );
};

const ContributorsDropdown = ({ contributors }) => {

    return (
        <div className="dropdown">
            <button
                className="btn btn-secondary btn-sm text-lg avatar avatar-xs rounded-circle"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
            >
                <div
                    className="avatar-img d-flex align-items-center justify-content-center"
                >
                    <span className="fs-6 text-white">
                        +{contributors.length}
                    </span>
                </div>
            </button>
            <div
                className="dropdown-menu p-3 mt-2 zindex-fixed overflow-auto"
                style={{ maxHeight: '240px' }}
            >
                <div className="d-flex flex-column gap-2">
                    {contributors.map(contributor => (
                        <ContributorDetails
                            contributor={contributor}
                            key={contributor.id}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

const ContributorDetails = ({
    contributor: {
        user,
        accessType,
        designation,
        avatarRingColor
    }
}) => {

    return (
        <div className="d-flex align-items-center gap-3">
            <div className={`border border-2 rounded-circle p-1 border-${avatarRingColor}`}>
                <UserAvatar user={user} />
            </div>
            <div className="text-nowrap small">
                {user.fullname}
                <div className="text-muted">
                    {designation || user.userType} - {ACCESS_TYPES[accessType]}
                </div>
            </div>
        </div>
    );
};

export const UserAvatar = ({ user }) => {

    return (
        <div className="avatar avatar-xs d-block">
            {!!user?.smallProfilePic ? (
                <img
                    src={user.smallProfilePic}
                    className="avatar-img rounded-circle"
                />
            ) : (
                <div
                    className="avatar-img rounded-circle d-flex align-items-center justify-content-center"
                    style={{ backgroundColor: user?.profileColor || 'black' }}
                >
                    <span className="fs-5 text-white">
                        {user?.nameInitials}
                    </span>
                </div>
            )}
        </div>
    );
}

export default Contributors;